import React from 'react';
import CheckboxSelect from './CheckboxSelect';
import StaticHtmlContent from '../../../common/staticHtmlContent';
import './checkbox.scss';


export const Checkbox = ({
    disabled,
    checked,
    label,
    name,
    onClick,
    size,
    variant = 'primary',
}) => {

    return (variant === 'select'
            ? <CheckboxSelect
                label={label}
                disabled={disabled}
                isChecked={checked}
                handleCheck={() => onClick()}
            />
            : <label className="bswh-checkbox checkbox-container">
                <input
                    type="checkbox"
                    name={name}
                    checked={checked}
                    onChange={() => onClick()}
                />
                <span className="checkmark" />
                {label && <span className="checkbox-label"><StaticHtmlContent content={label} /></span>}
            </label>
    )
}